import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import DarkModeToggle from './DarkModeToggle'

function Header() {
const { t } = useTranslation();
  
  return (
 <header className="bg-white dark:bg-gray-800 shadow-sm">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex justify-between h-16 items-center">
      <div className="flex-shrink-0">
        <Link to="/" className="text-primary-600 dark:text-primary-400 font-bold text-xl">
          {t('header.brand')}
        </Link>
      </div>
      
      <div className="flex items-center space-x-4">
        <DarkModeToggle />
        
        <nav className="flex space-x-4">
          <Link to="/" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400">
            {t('header.home')}
          </Link>

          <Link to="/dashboard" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400">
            {t('header.dashboard')}
          </Link>
          <button className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400">
            {t('header.logout')}
          </button>

          <Link to="/login" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400">
            {t('header.login')}
          </Link>
          <Link to="/register" className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400">
            {t('header.register')}
          </Link>
        </nav>
      </div>
    </div>
  </div>
</header>

  )
}

export default Header